import React from 'react';

import { GoodsDisplay, YesNoDisplay } from '@components/admin/members/MembershipFormDetails/Forms';
import { ChecklistForm, MembershipFormFields } from '@models/MembershipForm';
import { makeMuiStyles } from '@styles';

const useStyles = makeMuiStyles((_, common) => ({
  formContainer: {
    ...common.flexColumn,
    marginBottom: '1rem',
  },
}));

export const ChecklistDisplay: React.FC<{ values: ChecklistForm }> = ({ values }) => {
  const classes = useStyles();

  return (
    <div className={classes.formContainer}>
      <YesNoDisplay field={MembershipFormFields.shared.question1} value={values.question1} />
      <YesNoDisplay field={MembershipFormFields.shared.question2} value={values.question2} />
      <YesNoDisplay field={MembershipFormFields.shared.question3} value={values.question3} />
      <YesNoDisplay field={MembershipFormFields.shared.question4} value={values.question4} />
      <YesNoDisplay field={MembershipFormFields.shared.question5} value={values.question5} />
      <YesNoDisplay field={MembershipFormFields.shared.question6} value={values.question6} />
      <YesNoDisplay field={MembershipFormFields.shared.question7} value={values.question7} />
      <GoodsDisplay
        field={MembershipFormFields.shared.question8}
        value={values.question8}
        type="export"
      />
      <GoodsDisplay
        field={MembershipFormFields.shared.question9}
        value={values.question9}
        type="import"
      />
      <YesNoDisplay field={MembershipFormFields.shared.question10} value={values.question10} />
      <YesNoDisplay field={MembershipFormFields.shared.question11} value={values.question11} />
    </div>
  );
};
